import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import FooterLi from "./FooterLi";
import flag from "./icons8-usa-48.png";
import globe from "./icons8-globe-50.png";
import { Link } from "react-router-dom";
const footer1 = ["Careers", "Amazon Newsletter", "About Amazon", "Accessibility", "Sustainability", "Press Center", "Investor Relations", "Amazon Devices", "Amazon Science"];
const footer2 = ["Sell products on Amazon", "Sell apps on Amazon", "Supply to Amazon", "Protect & Build Your Brand", "Become an Affiliate", "Become a Delivery Driver", "Start a package delivery business", "Advertise Your Products", "Self-Publish with Us", "Host an Amazon Hub", "›See More Ways to Make Money"];
const footer3 = ["Amazon Rewards Visa Signature Cards", "Amazon Store Card", "Amazon Secured Card", "Amazon Business Card", "Shop with Points", "Credit Card Marketplace", "Reload Your Balance", "Amazon Currency Converter"];
const footer4 = ["Amazon and COVID-19", "Your Account", "Your Orders", "Shipping Rates & Policies", "Amazon Prime", "Returns & Replacements", "Manage Your Content and Devices", "Your Recalls and Product Safety Alerts", "Help"];

const Footer = () => {
    return (
        <>
            <div className="text-center pt-3 pb-3" style={{ backgroundColor: "#37475A", color: "white" }}>
                <Link className="text-decoration-none list-unstyled text-white" to="#" onClick={() => window.scrollTo(0, 0)}>
                    Back to Top
                </Link>
            </div>
            <div className="pb-5" style={{ backgroundColor: "#232F3E", color: "white" }}>
                <div style={{ borderBottom: "1px solid #3a4553" }}>
                    <div className="container pt-5 pb-3">
                        <div className="row">
                            <div className="col">
                                <h6 style={{ fontWeight: "700" }}>Get to Know Us</h6>
                                <ul className="list-unstyled">
                                    <FooterLi footer={footer1} />
                                </ul>
                            </div>
                            <div className="col">
                                <h6 style={{ fontWeight: "700" }}>Make Money with Us</h6>
                                <ul className="list-unstyled">
                                    <FooterLi footer={footer2} />
                                </ul>
                            </div>
                            <div className="col">
                                <h6 style={{ fontWeight: "700" }}>Amazon Payment Products</h6>
                                <ul className="list-unstyled">
                                    <FooterLi footer={footer3} />
                                </ul>
                            </div>
                            <div className="col">
                                <h6 style={{ fontWeight: "700" }}>Let Us Help You</h6>
                                <ul className="list-unstyled">
                                    <FooterLi footer={footer4} />
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="justify-content-center d-flex">
                    <div className="mt-4">
                        <img style={{ width: "80px", objectFit: "contain" }} src="https://pngimg.com/uploads/amazon/amazon_PNG11.png" />
                    </div>
                    <span style={{ border: "1px solid #848688" }} className="mt-3 pt-1 pe-3 d-flex me-2 ms-5">
                        <img className="ps-2 pt-1" style={{ width: "25px", height: "20px" }} src={globe} />
                        <span className="ps-1">English</span>
                    </span>
                    <span style={{ border: "1px solid #848688" }} className="mt-3 pt-1 pe-3 d-flex">
                        <img className="ps-2 pt-1" style={{ width: "25px", height: "20px" }} src={flag} />
                        <span className="ps-1">United States</span>
                    </span>
                </div>
            </div>
        </>
    );
};

export default Footer;
